<template>
  <section>
    <header>
      <div class="container">
        <h2>Ways You Can Help!</h2>
      </div>
    </header>
    <div class="content goldBg">
      <div class="container">
        <div class="flex">
          <div>
            <div class="module-content">
              <div class="icon">
                <img src="~assets/images/PFK_Icon_Backpack.svg" width="100" height="100">
              </div>
              <h5>Sponsor one backpack &mdash; just $60 each</h5>
              <p>Gift a child with a life-changing backpack, filled with necessary supplies — and change their future.</p>
            </div>
            <router-link to="/#donate" class="btn btn-lg btn-primary btn-block">Donate Now</router-link>
          </div>
          <div>
            <div class="module-content">
              <div class="icon">
                <img src="~assets/images/PFK_Icon_DonateHand.svg" width="100" height="100">
              </div>
              <h5>Make a sustaining donation</h5>
              <p>By becoming a sustaining donor, you help create a foundation of support for Pencils For Kids, Inc.</p>
            </div>
            <router-link to="/#donate" class="btn btn-lg btn-primary btn-block">Sign Up Now</router-link>
          </div>
          <div>
            <div class="module-content">
              <div class="icon">
                <img src="~assets/images/PFK_Icon_BigHandLittleHand.svg" width="100" height="100">
              </div>
              <h5>Join us at an event</h5>
              <p>You can support Pencils for Kids, Inc. by buying a ticket to an upcoming event. </p>
            </div>
            <router-link to="/#events" class="btn btn-lg btn-primary btn-block">Events</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ways-you-can-help'
}
</script>

<style lang="scss" scoped>
  @import '~assets/styles/vars';

  .container {
    @include media('desktop') {
      width: 900px;
    }
  }

  .goldBg {
    background-color: lighten($gold, 15%);
  }

  .module-content {
    @include media('tablet-wide') {
      min-height: 280px;
    }
  }

  section {
    header {
      height: 220px;
      background-image: url('~assets/images/PFK_Photo4_WaysHelp_2000x500.jpg');
      background-size: cover;
      display: flex;
      align-items: center;
      @include media('tablet-wide') {
        height: 330px;
      }
      h2 {
        font-size: 2.5em;
        text-align: right;
        color: $white;
      }
    }
    .content {
      padding: 80px 0;
    }
    .flex {
      display: block;
      @include media('tablet-wide') {
        display: flex;
        justify-content: space-between;
        > div {
          width: 26%;
        }
      }
      > div {
        max-width: 340px;
        margin: auto;
        margin-bottom: 3rem;
        @include media('tablet-wide') {
          margin-bottom: 0;
        }
        .icon {
          width: 90%;
          text-align: center;
          margin-bottom: 1rem;
        }
        h5 {
          font-size: 1rem;
          font-weight: bold;
          text-transform: uppercase;
          color: $brand-primary;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// WaysYouCanHelp.vue?96e5c8ce